import _ from "lodash";
import { RandonString } from "../utils/normalize-string/RandonString";

export class UserEntity {
    propsModel = "";
    isSuper = false;
    constructor(props) {
        this.props = props;
    }

    static restore(props) {
        const userEntity = new UserEntity(props);
        if (props.roles.includes("Super")) {
            userEntity.isSuper = true;
        }
        userEntity.propsModel = "meteor";
        return userEntity;
    }

    static restoreFromCloud(props) {
        const userEntity = new UserEntity(props);
        if (props.role === "Super") {
            userEntity.isSuper = true;
        }
        userEntity.propsModel = "cloud";
        return userEntity;
    }

    toJson() {
        return this.props;
    }

    getFortesAppSecret() {
        return `Bearer ${_.get(this.props, "apiToken.token")}`;
    }

    generatePassword() {
        this.props.password = RandonString.generatePassword();
    }

    setCompanyId(companyId) {
        this.props.profile.companyId = companyId;
        this.props.profile.companyIds = [companyId];
    }

    updatePicture(picture) {
        this.props.picture = picture;
    }

    updateTheme(theme) {
        this.props.theme = theme;
    }

    updateDashboardTheme(dashboardTheme) {
        this.props.dashboardTheme = dashboardTheme;
    }

    updateFeatureFlag(flag, value) {
        const safeFlag = String(flag).trim();
        if (!safeFlag) return;
        _.set(this.props, `featureFlag.${safeFlag}`, value);
    }

    updateStatus(status) {
        this.props.status = status;
    }

    getLastToken() {
        if (!this.props?.liveToken) return false;
        const tokensAvailable = this.props.liveToken.filter((token) => {
            return token.createdAt;
        });
        const tokens = tokensAvailable.map((token) => {
            return {
                ...token,
                createdAt: new Date(token.createdAt).toISOString()
            };
        });
        const sorted = _.sortBy(tokens, "createdAt");
        const lastToken = _.findLast(sorted, (token) => {
            if (_.size(token)) return token;
        });
        return _.get(lastToken, "token", "");
    }

    isInRole(roles) {
        return roles.some((role) => this.props.roles.includes(role));
    }

    get meteorModel() {
        const meteorModel = {};
        const cloudModel = this.props || {};
        const mappedPaths = {
            password: ["services.password.bcrypt"],
            accountingId: ["profile.accountingId"],
            accountingIds: ["profile.accountingIds"],
            companyIds: ["profile.companyIds"],
            groupIds: ["profile.groupIds"],
            name: ["profile.name"],
            nickname: ["profile.nickname"],
            status: ["profile.status"],
            type: ["profile.type"],
            onboarding: ["profile.onboarding"],
            picture: ["profile.picture"],
            hubspot: ["profile.hubspot"],
            studentId: ["profile.studentId"],
            featureFlag: ["profile.featureFlag"],
            whatsapp: ["profile.whatsapp"],
            email: ["emails[0].address"],
            benchmarkingCompanyId: ["profile.benchmarkingCompanyId"],
            benchmarkingCompanyIds: ["profile.benchmarkingCompanyIds"],
            apiToken: ["profile.apiToken"],
            permission: ["profile.permission"],
            dashboardTheme: ["profile.dashboardTheme"],
            theme: ["profile.theme"],
            isAnonimo: ["profile.isAnonimo"],
            stripeId: ["profile.stripeId"]
        };
        Object.entries(cloudModel).forEach(([key, value]) => {
            const paths = mappedPaths[key];
            if (!paths) {
                meteorModel[key] = value;
                return;
            }
            paths.forEach((path) => _.set(meteorModel, path, value));
        });
        return meteorModel;
    }
}
